import React from 'react';
import {Button} from 'antd';
import {tid} from '../../../../testUtils';

interface ModelUploadFooterAntdProps {
  onBack?: () => void;
  onNext?: () => void;
  onDraft?: () => void;
  onCancel?: () => void;
  backText?: string;
  nextText?: string;
  draftText?: string;
  cancelText?: string;
  disableNext?: boolean;
  showBack?: boolean;
  showNext?: boolean;
  showDraft?: boolean;
  showCancel?: boolean;
  nextHtmlType?: 'button' | 'submit' | 'reset';
}

const ModelUploadFooterAntd: React.FC<ModelUploadFooterAntdProps> = ({
  onBack,
  onNext,
  onDraft,
  onCancel,
  backText = 'Back',
  nextText = 'Save & Proceed',
  draftText = 'Save as Draft',
  cancelText = 'Cancel',
  disableNext = false,
  showBack = true,
  showNext = true,
  showDraft = false,
  showCancel = false,
  nextHtmlType = 'button',
}) => {
  return (
    <div
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#fff',
        borderTop: '1px solid #d9d9d9',
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '12px',
        zIndex: 1000,
      }}
    >
      {showCancel && (
        <Button size="large" onClick={onCancel} {...tid('btn-cancel')}>
          {cancelText}
        </Button>
      )}
      {showBack && !showCancel && (
        <Button size="large" onClick={onBack} {...tid('btn-back')}>
          {backText}
        </Button>
      )}
      {showDraft && (
        <Button size="large" onClick={onDraft} {...tid('btn-save-draft')}>
          {draftText}
        </Button>
      )}
      {showNext && (
        <Button
          type="primary"
          size="large"
          htmlType={nextHtmlType}
          onClick={onNext}
          disabled={disableNext}
          {...tid('btn-save-proceed')}
        >
          {nextText}
        </Button>
      )}
    </div>
  );
};

export default ModelUploadFooterAntd;
